const $ = jQuery.noConflict();

$(document).ready(function () {

  if (document.getElementById('terms-of-use')) {
    // Select all navigation links and content sections
    const navLinks = document.querySelectorAll('#terms-of-use .nav-link');
    const sections = document.querySelectorAll('#terms-of-use .content-section');

    //if the the scroll position is 0 then make the first nav link active
    if (window.scrollY === 0) {
      const firstActiveLink = document.querySelector('#terms-of-use .nav-link:first-child');
      firstActiveLink.classList.add('active');
    }

    // Create an IntersectionObserver instance
    const observer = new IntersectionObserver((entries) => {

      entries.forEach(entry => {

        // Check if the observed section is intersecting (visible)
        if (entry.isIntersecting) {

          // Remove the 'active' class from all links
          navLinks.forEach(link => {
            link.classList.remove('active');
          });

          // Get the ID of the intersecting section
          const targetId = entry.target.id;

          // Add the 'active' class to the corresponding navigation link
          const activeLink = document.querySelector(`a[href="#${targetId}"]`);
          if (activeLink) {
            activeLink.classList.add('active');
          }
        } else {
          entry.target.classList.remove('active');
        }
      });

    }, {
      // Options for the IntersectionObserver
      threshold: 0, // 50% of the section must be visible to be considered intersecting
      rootMargin: '0px 0px -90%' // Adjusted to trigger halfway down the viewport
    });

    // Observe each content section
    sections.forEach(section => {
      observer.observe(section);
    });

    // Add smooth scrolling for navigation links
    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          // Scroll smoothly to the target section
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }
      });
    });

    const navigation = document.querySelector('#terms-of-use .sticky-nav');
    const navAccordion = document.querySelector('#terms-of-use .sticky-nav .nav-link--open');

    navAccordion.addEventListener('click', function (e) {
      e.preventDefault();
      navigation.classList.toggle('expand');
    });
  }
});